import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import Axios from 'axios'
import VueBodyClass from 'vue-body-class';

// Router Layout
import MainLayout from '../layout/MainLayout.vue'

// Authentication
import Signin from '../views/auth/signin.vue'
import Signout from '../views/auth/signout.vue'
import Oauth from '../views/auth/oauth.vue'

// Main Router
import DashboardMain from '../views/dashboard/main.vue'
import DashboardStudent from '../views/dashboard/student.vue'
import SchoolMain from '../views/school/main.vue'
import UniversityMain from '../views/university/main.vue'
import SubjectMain from '../views/subject/main.vue'
import MasterMajor from '../views/master_major/main.vue'
import GroupSubjectMain from '../views/group-subject/main.vue'
import MajorMain from '../views/major/main.vue'
import PassingGradeAlumniMain from '../views/passing-grade-alumni/main.vue'
import PassingGradeAlumniUtbkMain from '../views/passing-grade-alumni-utbk/main.vue'
import PassingGradeMajorMain from '../views/passing-grade-major/main.vue'
import SuggestionMain from '../views/suggestion/main.vue'
import AchievementMain from '../views/achievement/main.vue'
import SchoolPartnerMain from '../views/school/partner.vue'
import TeacherPartnerMain from '../views/users/teacher-main.vue'
import ConsultantMain from '../views/users/consultant-main.vue'
import StudentMain from '../views/users/student-main.vue'
import SchoolPGAlumni from '../views/school-pg-alumni/main.vue'
import RationalizationMain from '../views/rationalization/main.vue'
import RationalizationForm from '../views/rationalization/form.vue'
import RationalizationEvaluation from '../views/rationalization/evaluation-result.vue'
import EligibleSchool from '../views/eligible-school/main.vue'
import StudentAchievement from '../views/users/student-achievement-main.vue'
import StudentRapor from '../views/student/rapor.vue'
import StudentSettingsMajor from '../views/student/settings-major.vue'
import StudentRationalization from '../views/student/rationalization.vue'
import StudentRationalizationDetail from '../views/student/rationalization-detail.vue'
import StudentAlumni from '../views/student/alumni.vue'
import StudentMajor from '../views/student/major.vue'
import StudentConsultation from '../views/student/consultation.vue'
import StudentTalent from '../views/student/talent.vue'
import StudentPromotion from '../views/student/promotion.vue'
import StudentAccompany from '../views/student/accompany.vue'
import StudentProfile from '../views/student/profile.vue'
import UsersImport from '../views/users/import-users.vue'
import MajorCodeReference from '../views/users/major-code-reference.vue'
import ScoreImport from '../views/users/import-score.vue'

Vue.use(VueRouter)
Vue.use(VueMeta);

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator','teacher','student']
    }
  },
  {
    path: '/dashboard-student',
    name: 'dashboard_student',
    component: DashboardStudent,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/school',
    name: 'school',
    component: SchoolMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/university',
    name: 'university',
    component: UniversityMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/major',
    name: 'major',
    component: MajorMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/subject',
    name: 'subject',
    component: SubjectMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/master-major',
    name: 'master_major',
    component: MasterMajor,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/group-subject',
    name: 'group_subject',
    component: GroupSubjectMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/passing-grade-alumni',
    name: 'passing_grade_alumni',
    component: PassingGradeAlumniMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/passing-grade-alumni-utbk',
    name: 'passing_grade_alumni_utbk',
    component: PassingGradeAlumniUtbkMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/passing-grade-major',
    name: 'passing_grade_major',
    component: PassingGradeMajorMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator','teacher']
    }
  },
  {
    path: '/suggestion',
    name: 'suggestion',
    component: SuggestionMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/achievement',
    name: 'achievement',
    component: AchievementMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/school-partner',
    name: 'school_partner',
    component: SchoolPartnerMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/teacher-partner',
    name: 'teacher_partner',
    component: TeacherPartnerMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/consultant',
    name: 'consultant',
    component: ConsultantMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator']
    }
  },
  {
    path: '/student',
    name: 'student',
    component: StudentMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['teacher']
    }
  },
  {
    path: '/school-pg-alumni',
    name: 'school_pg_alumni',
    component: SchoolPGAlumni,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['teacher']
    }
  },
  {
    path: '/rationalization',
    name: 'rationalization',
    component: RationalizationMain,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['teacher']
    }
  },
  {
    path: '/rationalization/form',
    name: 'rationalization_form_add',
    component: RationalizationForm,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['teacher']
    }
  },
  {
    path: '/rationalization/form/:code',
    name: 'rationalization_form_edit',
    component: RationalizationForm,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['teacher']
    }
  },
  {
    path: '/rationalization/evaluation/:id/:code',
    name: 'rationalization_evaluation',
    component: RationalizationEvaluation,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['teacher']
    }
  },
  {
    path: '/eligible-school',
    name: 'eligible_school',
    component: EligibleSchool,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['teacher']
    }
  },
  {
    path: '/student-achievement',
    name: 'student-achievement',
    component: StudentAchievement,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['teacher']
    }
  },
  {
    path: '/signin',
    name: 'signin',
    component: Signin,
    meta: {
      transition: 'fade'
    }
  },
  {
    path: '/signout',
    name: 'signout',
    component: Signout,
    meta: {
      transition: 'fade'
    }
  },
  {
    path: '/oauth/:token',
    name: 'oauth',
    component: Oauth,
    meta: {
      transition: 'fade'
    }
  },
  {
    path: '/student/my-rapor',
    name: 'student_rapor',
    component: StudentRapor,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/settings/major',
    name: 'student_settings_major',
    component: StudentSettingsMajor,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/rationalization',
    name: 'student_rationalization',
    component: StudentRationalization,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/rationalization/detail/:id/:code',
    name: 'student_rationalization_detail',
    component: StudentRationalizationDetail,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/alumni/',
    name: 'student_alumni',
    component: StudentAlumni,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/major/',
    name: 'student_major',
    component: StudentMajor,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/consultation/',
    name: 'student_consultation',
    component: StudentConsultation,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/talent/',
    name: 'student_talent',
    component: StudentTalent,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/promotion/',
    name: 'student_promotion',
    component: StudentPromotion,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/accompany/',
    name: 'student_accompany',
    component: StudentAccompany,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
    path: '/student/profile/',
    name: 'student_profile',
    component: StudentProfile,
    meta: {
      transition: 'fade',
      roles:['student']
    }
  },
  {
      path: '/import-data/:type',
      name: 'import_users',
      component: UsersImport,
      meta: {
        layout: MainLayout,
        transition: 'fade',
        roles:['administrator','teacher']
      }
    },
  {
    path: '/import-nilai-rapor',
    name: 'import_score',
    component: ScoreImport,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['teacher']
    }
  },
  {
    path: '/daftar-kode-jurusan',
    name: 'major_code_reference',
    component: MajorCodeReference,
    meta: {
      layout: MainLayout,
      transition: 'fade',
      roles:['administrator','teacher']
    }
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const vueBodyClass = new VueBodyClass(routes);
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages   = ['signin','oauth'];
  const authRequired  = !publicPages.includes(to.name);
  const token         = localStorage.getItem('gaspol_token');

  if (authRequired && token) {
      Axios.get(process.env.VUE_APP_APIHOST + 'users/info', {
          headers: {
              'Authorization': token
          }
      }).then(response => {
        if(response.data.logged_in) {
          let roles = response.data.role;
                  
          if(to.meta.roles.includes(roles)) {
              if(to.name == 'dashboard' && roles == 'student') {
                next({ name: 'dashboard_student' });
              } else {
                next();
              }
          } else {
              alert("Akses tidak diperbolehkan");
              next({ name: 'dashboard' });
          }
        } else {
          alert("Sesi login telah habis !");
          localStorage.removeItem('id');
          localStorage.removeItem('gaspol_token');
          next({ name: 'signin' });
        }
    }).catch(function (error) {
        console.debug(error);
    });
  }

  else if (authRequired && !token) {
    next({ name: 'signin' });
  }

  else {
    if(to.name == 'signin' || to.name == 'oauth') {
        if(token) {
            next({ name: 'dashboard' });
        } else {
            next();
        }
    }
    else {
        if(!token) {
            if(to.name == 'signout') {
                next({ name: 'signin' });
            } else {
                next();
            }
        } else {
            next();
        }
    }
  }

  vueBodyClass.guard(to, next);
});

export default router
